
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/[doc]",
      function () {
        return require("private-next-pages/terms/[doc].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/[doc]"])
      });
    }
  